module.exports = __webpack_public_path__ + "media/images/money-transfer-06fed103e1a0bba4360a940bdb43ce73.svg";